import { colors } from "../../shared/constants";

var setTooltipIconColor = function setTooltipIconColor(o, r) {
  return o ? colors.red3 : r ? colors.gray3 : colors.teal6;
};

export { setTooltipIconColor };